import React from "react";
import Meta from "../Components/Meta";
import { Button, Container, Group, GroupLabel, Row } from "../Components/ui";

const COMPANY = [
  ["会社名", "株式会社 GLANMA"],
  ["所在地", "〒612-0041 京都市伏見区深草北鍵屋町995-1"],
  ["設立", "2024年2月"],
  ["代表者", "代表取締役 城 翔貴"],
  ["電話番号", "09020422346"],
];

const AboutPage = () => {
  return (
    <div className="bg-fill-2 pb-20">
      <Meta title="会社情報|CAMARAGO" description="camaragoの会社情報ページです。" />
      <Container narrow className="pt-10 md:pt-16">
        <h1 className="px-1 text-[32px] font-bold leading-tight tracking-tight md:text-[44px]">当社について</h1>

        <div className="mt-8 rounded-[18px] bg-white p-6 md:p-8">
          <p className="text-[16px] leading-[1.9] text-body md:text-[17px]">
            CAMARAGO（カマラゴ）は、スペイン語の “Cámara（カメラ）” と英語の “Go（気軽さを想起するワード）”
            を組み合わせたサービス名です。私たちが持つ全国レベルの設置作業員ネットワークと、簡単で直感的に最適な防犯カメラ選びができるサービスを実現。すぐに使えて、どこでも設置できる、暮らしやビジネスにフィットする防犯カメラの設置を行います。面倒な選定や設置は一切不要。あなたにぴったりの防犯カメラを、スピーディーに、そして信頼できる形でご提供します。
          </p>
        </div>

        <div className="mt-10">
          <GroupLabel>企業理念</GroupLabel>
          <div className="rounded-[14px] bg-white px-4 py-4 text-[17px] leading-relaxed">
            私たちは「テクノロジーで安心を可視化する」ことを使命とし、誰もが安全に暮らせる社会の実現を目指します。
          </div>
        </div>

        <div className="mt-8">
          <GroupLabel>主なサービス</GroupLabel>
          <Group>
            <Row>防犯・監視カメラの提案と導入支援</Row>
            <Row>設置工事・保守メンテナンス</Row>
          </Group>
        </div>

        <div className="mt-8">
          <GroupLabel>会社概要</GroupLabel>
          <Group>
            {COMPANY.map(([label, value]) => (
              <Row key={label} className="!items-start">
                <span className="flex flex-col gap-0.5 sm:flex-row sm:gap-6">
                  <span className="w-24 shrink-0 text-ink-2">{label}</span>
                  <span>{value}</span>
                </span>
              </Row>
            ))}
          </Group>
        </div>

        <div className="mt-12 rounded-[18px] bg-white p-6 text-center">
          <p className="text-[17px] font-semibold">最適な防犯カメラを、いますぐ診断</p>
          <p className="mt-1 text-[15px] text-ink-2">質問に直感で答えるだけ。登録や入力は必要ありません。</p>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-6">
            <Button to="/wizard">無料で診断する</Button>
            <Button to="/contact" variant="plain">お問い合わせ ›</Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AboutPage;
